import api from '../services/api'; // Import your custom Axios instance

export const exportToExcel = async (selectedIds, apiEndpoint, filename) => {
  try {
    if (!selectedIds || selectedIds.length === 0) {
      throw new Error("No applicants selected for export");
    }

    console.log("Initiating export for IDs:", selectedIds);

    const response = await api.post(apiEndpoint, selectedIds, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.data) {
      throw new Error("Received empty response from server");
    }
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    return true;
  } catch (error) {
    console.error('Export failed:', {
      error: error.response?.data || error.message,
      status: error.response?.status,
    });

    let errorMessage = 'Export failed';
    if (error.response) {
      if (error.response.status === 400) {
        errorMessage = 'Invalid request data';
      } else if (error.response.status === 401) {
        errorMessage = 'Authorization required';
      } else if (error.response.status === 404) {
        errorMessage = 'No applicants found';
      }
    }

    throw new Error(errorMessage);
  }
};